export default{
	filters:{
    		numToString(value){
    			return value.toString()
    		}
    	},
}


// WEBPACK FOOTER //
// ./src/components/mixins/common.js